import { jsx as _jsx } from "react/jsx-runtime";
import { ToastContainer as DefaultToastContainer } from "react-toastify";
import { isDarkTheme } from "./theme";
function ToastContainer() {
    return (_jsx(DefaultToastContainer, { style: { zIndex: 999999 }, theme: isDarkTheme() ? "dark" : "light" }));
}
export default ToastContainer;
//# sourceMappingURL=ToastContainer.js.map